export function parseTripInfo(tripName) {
  const [location, dateStr] = tripName.split(/-(?=\d{4}-\d{2}-\d{2}$)/);
  // "greece-2026-09-28" → ["greece", "2026-09-28"]

  return dateStr;
}

export function formatTripDateRange(startDateStr, totalDays) {
  const startDate = new Date(startDateStr);
  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + (totalDays - 1));

  const options = {
    month: "short",
    day: "numeric",
    year: "numeric",
  };

  const startFormatted = startDate.toLocaleDateString("en-US", options);
  const endFormatted = endDate.toLocaleDateString("en-US", options);

  // return `${startFormatted} – ${endFormatted} (${totalDays} days / ${
  //   totalDays - 2
  // } nights)`;
  return (
    <span className="text-secondary font-medium">
      {startFormatted} – {endFormatted} ({totalDays} days / {totalDays - 2}{" "}
      nights)
    </span>
  );
}
